export const environment = {
  production: false,
  base_url: 'http://localhost:8081',
  socket_url: 'https://socket.medica.nvsite.xyz',
  client_id:
    '1031962399861-0dbevrmmnoomi5p3a198drfg5rtl51bi.apps.googleusercontent.com',
  //base_url: 'https://main.medica.nvsite.xyz',
  // socket_url: 'https://api.medica.nvsite.xyz'
  conexiones_url: 'https://conexiones.majasportswear.site',
  static_mesa_ayuda_url: 'http://localhost:8181',
  conexiones_nombre: {
    auth: 'MAIN',
    main: 'MAIN',
    puntoventa: 'PUNTO_VENTA',
    solicitudes: 'MESA_AYUDA',
    ecommerce: 'ECOMMERCE',
    reportes: 'REPORTES',
    gastos: 'GASTOS',
    wms: 'WMS',
    correos: 'APICORREOS',
    analisis: 'ANALISIS',
    shopifypos: 'SHOPIFYPOS',
    suministros: 'SUMINISTROS',
    canje: 'CANJE_ECOMMERCE',
  },
  //TODO: Cambiar a DEV una vez que finalize el desarrollo
  conexiones_entorno: 'QA',
  apipuntoventa_url: 'http://localhost:8000/puntoventa',
  articulos_excluidos: [9138187],
  cliente_excluido: ['SRL'],
  cliente_permitido: [11681],
  numeros_especiales: ['0123456789'],
  vale_permitido: 1,
  cambio_sin_ticket: 1,
  sucursal_recepcion_compras: 35842716,
  editar_dispositivo: 0,
  todos_clientes_shopify: 0,
  tipos_cliente_shopify: [
    'SRL',
  ],
  pin_conteo_traspaso: true,
};
